import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  siteMapPropType,
} from '@bingads-webui-campaign-react/with-site-map';
import { SummaryBarFactory } from '@bingads-webui-campaign-react/summary-bar';

export const GeneralSummaryBarLoader = (props) => {
  const {
    siteMap,
    updateAvailability,
    backButtonText,
    backButtonUrl,
    backButtonProps,
    ...others
  } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });
  // empty backbutton props mean we fill in with the LASTURL hoc.
  // null backbutton props means we dont show the backbutton at all.

  if (selectedParent) {
    if (_.isNull(backButtonProps) || backButtonUrl === null) {
      const modifiedBackButtonProps = {
        url: backButtonUrl,
        buttonText: backButtonText,
      };
      return (
        <SummaryBarFactory
          backButtonProps={modifiedBackButtonProps}
          {...others}
        />
      );
    }

    return (
      <SummaryBarFactory
        backButtonProps={backButtonProps}
        {...others}
      />
    );
  }

  return null;
};

GeneralSummaryBarLoader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  backButtonProps: PropTypes.shape({}),
  backButtonUrl: PropTypes.string,
  backButtonText: PropTypes.string,
};

GeneralSummaryBarLoader.defaultProps = {
  updateAvailability: _.noop,
  backButtonProps: null,
  backButtonUrl: null,
  backButtonText: null,
};

